import React from 'react';
import './OrbStepper.scss';
import clsx from 'clsx';

interface OrbStepperProps {
  steps: number;
  currentStep: number;
  className?: string;
}

export const OrbStepper: React.FC<OrbStepperProps> = ({
  steps,
  currentStep,
  className = '',
}) => {
  return (
    <div className={clsx('orb-stepper', className)}>
      {Array.from({ length: steps }).map((_, index) => (
        <React.Fragment key={index}>
          <div
            className={clsx('orb', {
              'orb--active': index + 1 === currentStep,
              'orb--completed': index + 1 < currentStep,
            })}
          />
          {index < steps - 1 && (
            <div
              className={clsx('line', {
                'line--filled': index + 1 < currentStep,
              })}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}; 